/* eslint-disable import/prefer-default-export */
import styled, { css, SimpleInterpolation } from 'styled-components';
import { Focus } from '@fenderdigital/ui/utils/css';

const PlayButtonCSS = css`
  background-color: transparent;
  border-radius: 50%;
  border-width: 5px;
  font-size: 2em;
  height: 95px;
  width: 95px;
  transition: none;
  top: 50%;
  left: 50%;
  margin: -2.5em auto auto -2.5em;
  .vjs-icon-placeholder {
    font-size: 4em;
    line-height: 1;
  }
  &:focus {
    ${Focus};
  }
  &:hover {
    transform: scale(1.1);
    transition: transform 0.25s ease 0s;
  }
`;

interface VideoContainerProps {
  isFullscreen?: boolean;
}

export const VideoContainer = styled.div<VideoContainerProps>`
  .video-js.vjs-fluid,
  video.vjs-tech {
    position: relative !important;
    width: 100%;
    height: auto !important;
    max-width: 100% !important;
    padding-top: 0 !important;
    line-height: 0;
    ${({ isFullscreen }): SimpleInterpolation =>
      isFullscreen
        ? css`
            height: 100% !important;
          `
        : css`
            @media screen and (min-width: 1025px) {
              height: 47vh !important;
            }
          `}
  }
  .video-js .vjs-big-play-button {
    ${PlayButtonCSS};
  }
  .video-js .vjs-time-control {
    display: block;
  }
  .video-js .vjs-remaining-time {
    display: none;
  }
`;
